import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getPartDataWithPartNOApi } from "../../../redux/reduxApi/website/MakeYearModel";
import { getProductPriceByUniceId } from "../../../redux/reduxApi/website/ProductReduxApi";

const PartDetils = () => {
  const dispatch = useDispatch();
  const [partNo, setPartNo] = useState("");
  const [partData, setPartData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [price, setPrice] = useState(null);

  const getData = async () => {
    try {
      setLoading(true);
      setError(null);
      setPrice(null);
      const resp = await dispatch(getPartDataWithPartNOApi(partNo));
      if (resp.payload?.ShowMeThePartsList?.partlistdata) {
        setPartData(resp.payload.ShowMeThePartsList.partlistdata);
        const part = resp.payload.ShowMeThePartsList.partlistdata;
        const price = await dispatch(getProductPriceByUniceId(part?.part_no + part?.aaiabrandid));
        console.log("this is price", price);
        setPrice(price.payload?.data?.productPricingresp[0]?.sellingPrice);
      }
    } catch (err) {
      setError("Failed to fetch part data. Please try again.");
      console.error("Error fetching part data:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Part Details Search</h1>

      <div className="flex gap-4 mb-8">
        <input
          type="text"
          value={partNo}
          onChange={(e) => setPartNo(e.target.value)}
          placeholder="Enter Part Number"
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button onClick={getData} disabled={loading} className={`px-6 py-2 rounded-lg text-white font-medium ${loading ? "bg-blue-400" : "bg-blue-600 hover:bg-blue-700"}`}>
          {loading ? "Searching..." : "Search"}
        </button>
      </div>

      {error && <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-lg">{error}</div>}

      {partData && (
        <div className="bg-white shadow-lg rounded-xl p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Image Section */}
            <div className="flex justify-center items-center bg-gray-100 rounded-lg p-4">
              <img
                src={partData.image}
                alt="Part visual"
                className="max-h-64 rounded-lg"
              // onError={(e) => {
              //   e.target.src = "https://via.placeholder.com/300";
              // }}
              />
            </div>

            {/* Details Section */}
            <div className="space-y-4">
              <h2 className="text-2xl font-semibold text-gray-800">{partData.part_no}</h2>
              <p className="text-lg text-gray-600">{partData.part_type}</p>
              <h2 className="text-2xl font-semibold text-gray-800">{price}</h2>
              {/* <h1 className=" "> {price}</h1> */}

              <div className="space-y-2">
                <DetailItem label="Supplier" value={partData.supplier} />
                <DetailItem label="Brand ID" value={partData.aaiabrandid} />
                <DetailItem label="Compatibility" value={partData.bg} />
                <DetailItem label="Dimensions" value={`${partData.width}mm x ${partData.height}mm`} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const DetailItem = ({ label, value }) => (
  <div className="flex justify-between items-center py-2 border-b border-gray-100">
    <span className="text-gray-500 font-medium">{label}:</span>
    <span className="text-gray-700">{value || "N/A"}</span>
  </div>
);

export default PartDetils;
